<div class="min-h-screen flex">
    <!-- Lewa strona - Formularz -->
    <div class="w-full lg:w-1/2 flex flex-col justify-center px-6 py-12 lg:px-16 xl:px-24 bg-white dark:bg-gray-900">
        <div class="max-w-md w-full mx-auto">
            <!-- Logo -->
            <div class="mb-8">
                <a routerLink="/" class="group inline-flex items-center gap-2.5">
                    <img class="h-8 w-8 rounded-lg object-contain transition-transform group-hover:scale-105" src="assets/images/logo-a.png" alt="Logo Fakturnia" width="32" height="32">
                    <span class="text-2xl font-bold tracking-tight text-gray-900 dark:text-white">Fakturnia</span>
                </a>
            </div>

            <!-- Krok 1: Odzyskiwanie konta -->
            <div *ngIf="step == 'restore-account'">
                <!-- Nagłówek -->
                <div class="mb-8">
                    <div class="w-14 h-14 rounded-2xl bg-amber-100 dark:bg-amber-900/30 flex items-center justify-center mb-4">
                        <mat-icon [svgIcon]="'tabler_outline:key'" class="!w-7 !h-7 text-amber-600 dark:text-amber-400"></mat-icon>
                    </div>
                    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                        Odzyskaj dostęp
                    </h1>
                    <p class="text-gray-600 dark:text-gray-400">
                        Podaj adres e-mail powiązany z Twoim kontem. Wyślemy link do zresetowania hasła.
                    </p>
                </div>

                <!-- Formularz -->
                <div class="bg-gray-50 dark:bg-gray-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
                    <mat-form-field class="w-full" subscriptSizing="dynamic">
                        <mat-label>Adres e-mail</mat-label>
                        <mat-icon matPrefix [svgIcon]="'tabler_outline:mail'" class="text-gray-400 mr-2"></mat-icon>
                        <input type="email" matInput lowercaseEmail [formControl]="restoreForm.controls.emailAddress" placeholder="jan.kowalski@firma.pl">
                        <mat-error *ngIf="restoreForm.controls.emailAddress.hasError('required')">Adres e-mail jest wymagany</mat-error>
                        <mat-error *ngIf="restoreForm.controls.emailAddress.hasError('invalidEmail')">Nieprawidłowy format adresu e-mail</mat-error>
                    </mat-form-field>

                    <button [disabled]="isProcessing" mat-flat-button color="primary" class="w-full mt-4 h-12 text-base" (click)="restore()">
                        <mat-icon *ngIf="isProcessing" [svgIcon]="'tabler_outline:loader'" class="icn-spinner mr-2"></mat-icon>
                        <span *ngIf="!isProcessing">Wyślij link resetujący</span>
                        <span *ngIf="isProcessing">Wysyłanie...</span>
                    </button>
                </div>

                <!-- Info box -->
                <div class="mt-6 p-4 bg-blue-50 dark:bg-blue-900/20 rounded-xl border border-blue-100 dark:border-blue-800">
                    <div class="flex gap-3">
                        <mat-icon [svgIcon]="'tabler_outline:info-circle'" class="!w-5 !h-5 text-blue-500 flex-shrink-0 mt-0.5"></mat-icon>
                        <div class="text-sm text-blue-700 dark:text-blue-300">
                            <p class="font-medium mb-1">Nie otrzymujesz e-maila?</p>
                            <p class="text-blue-600 dark:text-blue-400">Sprawdź folder SPAM lub poczekaj kilka minut. Jeśli problem się powtarza, skontaktuj się z nami.</p>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Krok 2: Ustawianie nowego hasła -->
            <div *ngIf="step == 'set-new-password'">
                <!-- Nagłówek -->
                <div class="mb-8">
                    <div class="w-14 h-14 rounded-2xl bg-green-100 dark:bg-green-900/30 flex items-center justify-center mb-4">
                        <mat-icon [svgIcon]="'tabler_outline:lock-check'" class="!w-7 !h-7 text-green-600 dark:text-green-400"></mat-icon>
                    </div>
                    <h1 class="text-3xl font-bold text-gray-900 dark:text-white mb-2">
                        Ustaw nowe hasło
                    </h1>
                    <p class="text-gray-600 dark:text-gray-400">
                        Wybierz silne hasło, które będzie chronić Twoje konto.
                    </p>
                </div>

                <!-- Formularz -->
                <div class="bg-gray-50 dark:bg-gray-800/50 rounded-2xl p-6 border border-gray-100 dark:border-gray-700">
                    <mat-form-field class="w-full" subscriptSizing="dynamic">
                        <mat-label>Nowe hasło</mat-label>
                        <mat-icon matPrefix [svgIcon]="'tabler_outline:lock'" class="text-gray-400 mr-2"></mat-icon>
                        <input [type]="showPassword ? 'text' : 'password'" matInput [formControl]="newPasswordForm.controls.password" placeholder="Minimum 8 znaków">
                        <button mat-icon-button matSuffix (click)="showPassword = !showPassword" type="button">
                            <mat-icon [svgIcon]="showPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
                        </button>
                        <mat-error *ngIf="newPasswordForm.controls.password.hasError('required')">Hasło jest wymagane</mat-error>
                        <mat-error *ngIf="newPasswordForm.controls.password.hasError('minlength')">Hasło musi zawierać minimum 8 znaków</mat-error>
                    </mat-form-field>

                    <mat-form-field class="w-full mt-2" subscriptSizing="dynamic">
                        <mat-label>Powtórz nowe hasło</mat-label>
                        <mat-icon matPrefix [svgIcon]="'tabler_outline:lock'" class="text-gray-400 mr-2"></mat-icon>
                        <input [type]="showRepeatPassword ? 'text' : 'password'" matInput [formControl]="newPasswordForm.controls.repeatPassword" placeholder="Powtórz hasło">
                        <button mat-icon-button matSuffix (click)="showRepeatPassword = !showRepeatPassword" type="button">
                            <mat-icon [svgIcon]="showRepeatPassword ? 'tabler_outline:eye-off' : 'tabler_outline:eye'"></mat-icon>
                        </button>
                        <mat-error *ngIf="newPasswordForm.controls.repeatPassword.hasError('matchFields')">Hasła muszą być identyczne</mat-error>
                    </mat-form-field>

                    <button [disabled]="isProcessing" mat-flat-button color="primary" class="w-full mt-4 h-12 text-base" (click)="setNewPassword()">
                        <mat-icon *ngIf="isProcessing" [svgIcon]="'tabler_outline:loader'" class="icn-spinner mr-2"></mat-icon>
                        <span *ngIf="!isProcessing">Zapisz nowe hasło</span>
                        <span *ngIf="isProcessing">Zapisywanie...</span>
                    </button>
                </div>

                <!-- Wskazówki dotyczące hasła -->
                <div class="mt-6 p-4 bg-gray-50 dark:bg-gray-800/50 rounded-xl border border-gray-100 dark:border-gray-700">
                    <p class="text-sm font-medium text-gray-700 dark:text-gray-300 mb-3">Silne hasło powinno zawierać:</p>
                    <div class="space-y-2 text-sm text-gray-600 dark:text-gray-400">
                        <div class="flex items-center gap-2">
                            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4 text-green-500"></mat-icon>
                            <span>Minimum 8 znaków</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4 text-green-500"></mat-icon>
                            <span>Duże i małe litery</span>
                        </div>
                        <div class="flex items-center gap-2">
                            <mat-icon [svgIcon]="'tabler_outline:check'" class="!w-4 !h-4 text-green-500"></mat-icon>
                            <span>Cyfry i znaki specjalne</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Separator -->
            <div class="relative my-8">
                <div class="absolute inset-0 flex items-center">
                    <div class="w-full border-t border-gray-200 dark:border-gray-700"></div>
                </div>
                <div class="relative flex justify-center text-sm">
                    <span class="px-4 bg-white dark:bg-gray-900 text-gray-500">Pamiętasz hasło?</span>
                </div>
            </div>

            <!-- Przycisk logowania -->
            <a routerLink="/logowanie" 
               class="w-full flex items-center justify-center gap-2 px-6 py-3 border-2 border-gray-200 dark:border-gray-700 rounded-xl font-semibold text-gray-700 dark:text-gray-300 hover:border-primary-500 hover:text-primary-600 dark:hover:text-primary-400 transition-all duration-200 group">
                <mat-icon [svgIcon]="'tabler_outline:arrow-left'" class="!w-5 !h-5 transition-transform group-hover:-translate-x-1"></mat-icon>
                <span>Wróć do logowania</span>
            </a>
        </div>
    </div>

    <!-- Prawa strona - Graficzna sekcja -->
    <div class="hidden lg:flex lg:w-1/2 relative bg-gradient-to-br from-amber-500 via-orange-600 to-red-700 overflow-hidden">
        <!-- Dekoracyjne elementy -->
        <div class="absolute inset-0">
            <div class="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full -translate-x-1/2 -translate-y-1/2 blur-3xl"></div>
            <div class="absolute bottom-0 right-0 w-80 h-80 bg-red-500/20 rounded-full translate-x-1/3 translate-y-1/3 blur-3xl"></div>
            <div class="absolute top-1/2 right-1/4 w-48 h-48 bg-orange-400/10 rounded-full"></div>
        </div>

        <!-- Treść -->
        <div class="relative z-10 flex flex-col justify-center px-12 xl:px-20 text-white">
            <div class="max-w-lg">
                <!-- Ikona -->
                <div class="w-16 h-16 rounded-2xl bg-white/20 backdrop-blur-sm flex items-center justify-center mb-8">
                    <mat-icon [svgIcon]="'tabler_outline:shield-lock'" class="!w-8 !h-8 text-white"></mat-icon>
                </div>

                <h2 class="text-4xl xl:text-5xl font-bold mb-6 leading-tight">
                    Twoje dane<br>
                    <span class="text-amber-200">są bezpieczne</span>
                </h2>

                <p class="text-lg text-white/80 mb-10">
                    Dbamy o bezpieczeństwo Twojego konta. Link do resetowania hasła jest ważny tylko przez 24 godziny.
                </p>

                <!-- Bezpieczeństwo -->
                <div class="space-y-4">
                    <div class="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4">
                        <mat-icon [svgIcon]="'tabler_outline:lock'" class="!w-6 !h-6 text-amber-200"></mat-icon>
                        <div>
                            <div class="font-semibold">Szyfrowanie end-to-end</div>
                            <div class="text-sm text-white/70">Wszystkie dane są szyfrowane</div>
                        </div>
                    </div>
                    <div class="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4">
                        <mat-icon [svgIcon]="'tabler_outline:clock'" class="!w-6 !h-6 text-amber-200"></mat-icon>
                        <div>
                            <div class="font-semibold">Link ważny 24h</div>
                            <div class="text-sm text-white/70">Dla dodatkowego bezpieczeństwa</div>
                        </div>
                    </div>
                    <div class="flex items-center gap-4 bg-white/10 backdrop-blur-sm rounded-xl p-4">
                        <mat-icon [svgIcon]="'tabler_outline:mail-check'" class="!w-6 !h-6 text-amber-200"></mat-icon>
                        <div>
                            <div class="font-semibold">Weryfikacja e-mail</div>
                            <div class="text-sm text-white/70">Tylko Ty możesz zresetować hasło</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
